import { Box, Card, CardHeader, styled } from '@mui/material';
import Grid from '@mui/material/Grid';
import { BodySmallRegular } from 'v3/shared/typography/BodySmall';

export const CardStyled = styled(Card)(({ theme }) => ({
  width: '100%',
  color: theme.palette.common.white,
  background: theme.palette.primary.dark,
  border: `1px solid ${theme.palette.secondary.dark}`,
}));

export const CardHeaderStyled = styled(CardHeader)(({ theme }) => ({
  display: 'flex',
  justifyItems: 'center',
  alignItems: 'center',
  borderBottom: `1px solid ${theme.palette.secondary.dark}`,
  backgroundColor: theme.palette.primary.main,
}));

export const Content = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  gap: '1rem',
}));

export const BodySmallRegularStyled = styled(BodySmallRegular)(({ theme }) => ({
  color: theme.palette.secondary.dark,
}));

export const LeftAlignedGrid = styled(Grid)(({ theme }) => ({
  justifyContent: 'flex-start',
  marginLeft: 0,
  marginRight: 'auto',
  width: 'fit-content',
}));

export const GridItem = styled(Grid)(({ theme }) => ({
  flexBasis: '50%',
  flexGrow: 0,
  maxWidth: '50%',
  wordBreak: 'break-word',

  [theme.breakpoints.up('md')]: {
    flexBasis: '25%',
    maxWidth: '20%',
  },
}));

export const GridFinancingItem = styled(Grid)(({ theme }) => ({
  flexBasis: '50%',
  flexGrow: 0,
  maxWidth: '50%',
  wordBreak: 'break-word',

  [theme.breakpoints.up('md')]: {
    flexBasis: '50%',
    maxWidth: '30%',
  },
}));

export const TextBreakable = styled('div')(() => ({
  overflowWrap: 'break-word',
  whiteSpace: 'normal',
}));

export const StatusDot = styled('span')<{ color?: string }>(({ color, theme }) => ({
  width: '0.5rem',
  height: '0.5rem',
  borderRadius: '50%',
  backgroundColor: color || theme.palette.secondary.light,
  display: 'inline-block',
  marginRight: '0.5rem',
}));

export const StatusValueContainer = styled('div')(() => ({
  display: 'flex',
  alignItems: 'center',
}));
